<div>
  <idp-session-time-out
    (logout)="logout()"
    (keepMeLoggedIn)="keepMeLoggedIn()"
    [sessionTimeOutContent]="sessionTimeOutModelContent || emptyContentDetails"
  ></idp-session-time-out>
</div>
